@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.TableLogColor {
  @extend %font-family-primary;

  &.inline-flex {
    display: inline-flex;
  }

  &.inline {
    display: inline;
  }

  &.blue {
    color: $theme-log-text-initializing;
  }

  &.green {
    color: $theme-log-text-success;
  }

  &.red {
    color: $theme-log-text-error;
  }

  &.orange {
    color: $theme-log-text-orange;
  }
}
